/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const postsContainer = $( '.blog-results-wrapper' )[0];

      /*
       * Search with a new category
       */
      $( 'select[name="category"]' ).on( 'change', function( e ) {
        const termID = $( this ).val();
        const termName = $( this ).find( 'option[value="' + $( this ).val() + '"]' ).text();
        let termInList = false;

        // Check if term already in list
        $( '.current-filters-list li' ).each( function() {
          if ( $( this ).find( '.term' ).text().trim() == termName ) {
            termInList = true;
          }
        } );

        // Add the term to the list if it is not already there
        if ( !termInList ) {
          $( this ).find( 'option[value="' + $( this ).val() + '"]' ).attr( 'disabled', true );
          $( '.current-filters-list' ).append( '<li><span class="term" data-id="' + termID + '">' + termName + ' <svg class="icon icon-remove"><use xlink:href="#icon-remove"></use></svg></span></li>' );
        }

        // Reset the select
        $( 'select[name="category"]' ).val( '' );

        // Show the current filters if not already shown
        $( '.current-filters' ).show();

        $( postsContainer ).attr( 'data-page', '1' );
        filterPosts();
      } );

      /*
       * Remove a term
       */
      $( document ).on( 'click', '.current-filters-list .term .icon', function() {
        $( this ).closest( 'li' ).remove();
        $( 'select[name="category"]' ).find( 'option[value="' + $( this ).closest( '.term' ).attr( 'data-id' ) + '"]' ).removeAttr( 'disabled' );

        if ( $( '.current-filters-list li' ).length == 0 ) {
          $( '.current-filters' ).hide();
        } else {
          $( '.current-filters' ).show();
        }
        $( postsContainer ).attr( 'data-page', '1' );
        filterPosts();
      } );

      /*
       * Clear all filters
       */
      $( document ).on( 'click', '.filter-clear', function() {
        $( '.current-filters-list li' ).remove();
        $( '.current-filters' ).hide();
        $( 'select[name="category"]' ).find( 'option:not(.placeholder)' ).removeAttr( 'disabled' );
        $( postsContainer ).attr( 'data-page', '1' );
        filterPosts();
      } );

      /*
       * If you submit the form with text, search with the text too
       */
      $( '.filter-form' ).on( 'submit', function( e ) {
        e.preventDefault();

        if ( $( 'input[name="search"]' ).val().length > 1 ) {
          $( '.current-filters-list .term[data-id="searched-term"]' ).parent().remove();
          $( '.current-filters-list' ).append( '<li><span class="term" data-id="searched-term">' + $( 'input[name="search"]' ).val() + ' <svg class="icon icon-remove"><use xlink:href="#icon-remove"></use></svg></span></li>' );

          // Show the current filters if not already shown
          $( '.current-filters' ).show();
        } else {
          $( '.current-filters-list .term[data-id="searched-term"]' ).parent().remove();
          if ( $( '.current-filters-list li' ).length == 0 ) {
            $( '.current-filters' ).hide();
          } else {
            $( '.current-filters' ).show();
          }
        }
        $( 'input[name="search"]' ).val( '' );
        $( postsContainer ).attr( 'data-page', '1' );
        filterPosts();
      } );

      /*
       * Go to a page via pagination
       */
      $( document ).on( 'click', '.pagination a', function( e ) {
        e.preventDefault();
        if ( $( this ).not( '.prev, .next' ).hasClass( 'page-numbers' ) ) {
          $( postsContainer ).attr( 'data-page', $( this ).text() );
        } else if ( $( this ).hasClass( 'prev' ) ) {
          const prevPage = parseInt( $( postsContainer ).attr( 'data-page' ) ) - 1;
          $( postsContainer ).attr( 'data-page', prevPage );
        } else if ( $( this ).hasClass( 'next' ) ) {
          const nextPage = parseInt( $( postsContainer ).attr( 'data-page' ) ) + 1;
          $( postsContainer ).attr( 'data-page', nextPage );
        }
        filterPosts();
      } );

      function filterPosts() {
        let doingAjax = false;

        const categories = [];
        let search = '';

        $( '.current-filters-list li' ).each( function() {
          if ( $( this ).find( '.term' ).attr( 'data-id' ) == 'searched-term' ) {
            search = $( this ).find( '.term' ).text().trim();
          } else {
            categories.push( $( this ).find( '.term' ).attr( 'data-id' ) );
          }
        } );

        const data = {
          'ppp': $( postsContainer ).attr( 'data-ppp' ),
          'page': $( postsContainer ).attr( 'data-page' ),
          'categories': categories,
          'search': search,
          'author': $( postsContainer ).attr( 'data-author' ),
        };

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/filterPosts',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( postsContainer ).html( data.content );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'blog', COMPONENT );
} )( app );
